import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClusterService } from 'src/app/core/cluster.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';

interface ClusterUsuryThresholdRow {
  cluster_code: string;
  steps_number: number;
  max_tan: number;
}

@Component({
  selector: 'app-cluster-update-usury-threshold-dialog',
  templateUrl: './cluster-update-usury-threshold-dialog.component.html',
  styleUrls: ['./cluster-update-usury-threshold-dialog.component.scss'],
})
export class ClusterUpdateUsuryThresholdDialogComponent {
  cluster_update_usury_threshold_form_group: FormGroup = this.form_service.cluster_update_usury_threshold_form_group;
  row?: ClusterUsuryThresholdRow;
  is_submit_running: boolean = false;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;

  constructor(
    private dialog_ref: MatDialogRef<ClusterUpdateUsuryThresholdDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private cluster_service: ClusterService,
    private form_service: FormService,
    private error_service: ErrorService,
  ) {
    this.row = data.row;
  }

  ngOnInit(): void {
    this.cluster_update_usury_threshold_form_group.reset();
    this.cluster_update_usury_threshold_form_group.patchValue({ max_tan: this.row ? this.row.max_tan / 100 : undefined });
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.cluster_update_usury_threshold_form_group);
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onSubmitClick(): void {
    if (!this.isFormValid() || !this.row) return;

    const max_tan = Number(this.cluster_update_usury_threshold_form_group.get('max_tan')?.value);

    this.is_submit_running = true;
    this.cluster_service.updateUsuryThreshold(this.row.cluster_code, this.row.steps_number, max_tan).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_submit_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_submit_running = false;
      },
    });
  }
}
